<template>
  <div>
    <v-dialog v-model="dialog" width="700">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" fab v-on="on" :loading="isCreating">
          <v-icon color="black">add</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-toolbar dark>
          <v-toolbar-title
            >{{ selectedIndex == -1 ? "Create" : "Edit" }} Base
            Distance</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="height: 70vh; overflow: scroll">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card v-if="province">
              <div style="padding: 10px 20px">
                <div style="font-size: 20px">Distance category</div>
              </div>
              <v-divider class="mx-3"></v-divider>
              <v-card-text>
                <v-radio-group
                  hide-details
                  row
                  v-model="form.distance_category"
                  @change="form.distance_district = []"
                >
                  <v-radio
                    :label="`All District`"
                    color="primary"
                    :value="1"
                    :disabled="selectedIndex == -2"
                  ></v-radio>
                  <v-radio
                    :label="`Some Districts`"
                    color="primary"
                    :value="2"
                    :disabled="selectedIndex == -2"
                  ></v-radio>
                </v-radio-group>
                <v-select
                  v-if="form.distance_category == 2"
                  chip
                  multiple
                  :items="districtList"
                  v-model="form.distance_district"
                  label="Select District"
                  item-text="district_name_th"
                  item-value="district_id"
                  clearable
                  :rules="[(v) => v.length > 0 || 'required']"
                  @change="form.distance_store = []"
                ></v-select> </v-card-text
            ></v-card>
            <v-card v-if="province" class="mt-3">
              <div style="padding: 10px 20px">
                <div style="font-size: 20px">Store category</div>
              </div>
              <v-divider class="mx-3"></v-divider>
              <v-card-text>
                <v-radio-group
                  hide-details
                  row
                  v-model="storeCategory"
                  @change="form.distance_store = []"
                >
                  <v-radio
                    :label="`All Store`"
                    color="primary"
                    :value="1"
                    :disabled="selectedIndex == -2"
                  ></v-radio>
                  <v-radio
                    :label="`Some Store`"
                    color="primary"
                    :value="2"
                    :disabled="selectedIndex == -2"
                  ></v-radio>
                </v-radio-group>
                <v-autocomplete
                  v-if="storeCategory == 2"
                  chip
                  multiple
                  :items="filteredBaseDistanceStore"
                  v-model="form.distance_store"
                  label="Select Store"
                  item-text="store_name_th"
                  item-value="store_id"
                  clearable
                  :rules="[(v) => v.length > 0 || 'required']"
                ></v-autocomplete> </v-card-text
            ></v-card>
            <v-card
              flat
              class="mt-3"
              style="border: 1px solid rgba(0, 0, 0, 0.12); border-radius: 5px"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  padding: 5px 20px 0px 20px;
                "
              >
                <div style="font-size: 20px">Distance condition list</div>
                <v-btn icon @click="moreCondition()">
                  <v-icon>add</v-icon>
                </v-btn>
              </div>
              <v-divider class="mx-3"></v-divider>
              <v-card-text>
                <div v-for="(info, index) in form.distance_text" :key="index">
                  <div
                    style="
                      height: 50px;
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <span style="font-size: 16px"
                      >Condition #{{ index + 1 }}</span
                    >
                    <v-btn
                      v-if="index > 0"
                      @click="removeCondition(index)"
                      icon
                    >
                      <v-icon size="20" color="red">delete</v-icon>
                    </v-btn>
                  </div>
                  <v-layout row wrap align-center>
                    <v-flex
                      :sm3="fixedPrice"
                      :sm4="!fixedPrice"
                      xs12
                      class="pr-2"
                    >
                      <v-text-field
                        type="number"
                        class="inputNumber"
                        v-model="info.transport_charge_start"
                        label="Distance start (m.)"
                        :rules="[
                          (v) =>
                            typeof v == 'number' ||
                            !!v ||
                            'Distance start is required',
                          (v) =>
                            validateStart(v, index) ||
                            'Distance start must be more than previous Distance end',
                        ]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      :sm3="fixedPrice"
                      :sm4="!fixedPrice"
                      xs12
                      class="pr-2"
                    >
                      <v-text-field
                        type="number"
                        class="inputNumber"
                        v-model="info.transport_charge_end"
                        label="Distance end (m.)"
                        :rules="[
                          (v) =>
                            typeof v == 'number' ||
                            !!v ||
                            'Distance end is required',
                          (v) =>
                            validateEnd(v, index) ||
                            'Distance end must be more than Distance start',
                        ]"
                      ></v-text-field>
                    </v-flex>

                    <v-flex
                      :sm3="fixedPrice"
                      :sm4="!fixedPrice"
                      :xs8="fixedPrice"
                      :xs12="!fixedPrice"
                      class="pr-2"
                    >
                      <v-text-field
                        type="number"
                        class="inputNumber"
                        v-model="info.transport_charge_price"
                        label="Charge price (฿)"
                        :rules="[
                          (v) =>
                            typeof v == 'number' ||
                            !!v ||
                            'Charge price is required',
                        ]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3 v-if="fixedPrice">
                      <v-checkbox
                        v-model="info.is_fixed_price"
                        label="Fixed price"
                      ></v-checkbox
                    ></v-flex>
                  </v-layout>
                </div>
              </v-card-text>
            </v-card>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outline color="error" @click="resetForm()">reset</v-btn>
          <v-btn outline color="success" @click="createBaseDistance()"
            >save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    province: {
      type: Boolean,
      default() {
        return false;
      },
    },
    fixedPrice: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isCreating: {
      type: Boolean,
      default() {
        return false;
      },
    },
    selectedIndex: {
      default() {
        return -1;
      },
    },
    districtList: {},
    selectedItem: {
      default() {
        return {
          distance_text: [],
          distance_district: [],
          distance_store: [],
        };
      },
    },
  },
  data() {
    return {
      valid: true,
      form: {
        distance_text: [
          {
            transport_charge_start: 0,
            transport_charge_end: 0,
            transport_charge_price: 0,
            is_fixed_price: false,
          },
        ],
        distance_district: [],
        distance_store: [],
        distance_category: 1,
        distance_status: false,
      },
      dialog: false,
      storeCategory: 1,
    };
  },
  watch: {
    dialog() {
      if (this.dialog == false) {
        this.$emit("onResetForm");
      } else {
        if (this.selectedIndex != -1) {
          this.form = JSON.parse(JSON.stringify(this.selectedItem));
          if (this.form.distance_store.length == 0) {
            this.storeCategory = 1;
          } else {
            this.storeCategory = 2;
          }
        }
      }
    },
  },
  computed: {
    ...mapGetters({ baseDistanceStore: "fetchStoreBack/baseDistanceStore" }),
    filteredBaseDistanceStore() {
      return this.baseDistanceStore.filter(
        (val) =>
          this.form.distance_district.includes(val.store_district_id) ||
          this.form.distance_category == 1
      );
    },
  },
  methods: {
    validateStart(value, index) {
      if (index == 0) {
        return true;
      } else {
        return (
          value >
          parseFloat(this.form.distance_text[index - 1].transport_charge_end)
        );
      }
    },
    validateEnd(value, index) {
      return (
        value >
        parseFloat(this.form.distance_text[index].transport_charge_start)
      );
    },
    removeCondition(index) {
      if (this.form.distance_text.length > 1) {
        this.form.distance_text.splice(index, 1);
      }
    },
    moreCondition() {
      this.form.distance_text.push({
        transport_charge_start: 0,
        transport_charge_end: 0,
        transport_charge_price: 0,
        is_fixed_price: false,
      });
    },
    resetForm() {
      this.form = {
        distance_text: [
          {
            transport_charge_start: 0,
            transport_charge_end: 0,
            transport_charge_price: 0,
            is_fixed_price: false,
          },
        ],
        distance_district: [],
        distance_store: [],
        distance_category: 1,
        distance_status: false,
      };
      this.$refs.form.resetValidation();
      this.storeCategory = 1;
    },
    async closeDialog() {
      this.dialog = false;
      this.resetForm();
    },
    async createBaseDistance() {
      let _this = this;
      if (this.$refs.form.validate()) {
        if (this.selectedIndex == -1) {
          this.$emit("onCreate", {
            form: _this.form,
            done() {
              _this.resetForm();
              _this.dialog = false;
            },
          });
        } else {
          this.$emit("onEdit", {
            form: _this.form,
            done() {
              _this.resetForm();
              _this.dialog = false;
            },
          });
        }
      }
    },
  },
};
</script>
<style>
.inputNumber input[type="number"] {
  -moz-appearance: textfield;
}
.inputNumber input::-webkit-outer-spin-button,
.inputNumber input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>
<style scoped>
.loading-section {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.loading-item {
  animation: fade 2s infinite linear;
}
.loading-item-span {
  font-size: 28px;
}
</style>
